import { SPEC_COURSE_LESSON_MODE } from 'common.components/spec-course-lesson-view/typings';

export const getResultsDescriptionId = (mode: SPEC_COURSE_LESSON_MODE): string | null => {
    const resultsAreNotAvailable = [
        SPEC_COURSE_LESSON_MODE.CONTROL_WORK_IN_PROGRESS,
        SPEC_COURSE_LESSON_MODE.WAITING_FOR_RESULTS,
    ].includes(mode);

    if (resultsAreNotAvailable) {
        return 'specCourse.lessonView.resultsTable.resultsAreNotAvailable.description';
    }

    if (mode === SPEC_COURSE_LESSON_MODE.CONTROL_WORK_FINISHED) {
        return 'specCourse.lessonView.resultsTable.results.description';
    }

    return null;
};
